import * as React from 'react';
import { AppState } from 'types';
import {
  IProductFeatureContext,
  ProductFeatureContext,
} from '@tock/shared/utils/productFeatureContext';

interface Props {
  activeProductFeatureSet: AppState['activeProductFeatureSet'];
  children?: React.ReactNode;
}

export default class ProductFeatureProvider extends React.PureComponent<Props> {
  render() {
    const value: IProductFeatureContext = this.props.activeProductFeatureSet || {};
    return (
      <ProductFeatureContext.Provider value={value}>
        {this.props.children}
      </ProductFeatureContext.Provider>
    );
  }
}
